import { useCallback } from 'react';

import { VisitTemplate, VisitTemplateUpdateCommand } from '@dreryk/egabinet-visit-frontend-api';

import { PromiseVoidFunction } from '@dreryk/react-common';
import { Choice } from '@dreryk/watermelon';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { visitTemplatesTranslationKeys } from '../translations';

import { VisitTemplateFormBean, VisitTemplateFormController } from './form/VisitTemplateForm.types';

type VisitTemplatesUpdateTemplateButtonProps = {
   readonly handleSubmit: VisitTemplateFormController['handleSubmit'];
   readonly onSuccess: PromiseVoidFunction;
   readonly disabled: boolean;
   readonly shouldConfirmEmptyTemplate: boolean;
};

export const VisitTemplatesUpdateTemplateButton = (props: VisitTemplatesUpdateTemplateButtonProps): JSX.Element => {
   const commandCreator = useCallback((variables: VisitTemplateFormBean, templateId: number) => {
      const command = new VisitTemplateUpdateCommand();
      command.id = templateId;
      command.parameters = {
         name: variables.name,
         interview: Choice.withUseDefaultIfNull(variables.interview?.getFormattedValue() ?? null),
         physicalExamination: Choice.withUseDefaultIfNull(variables.subjectiveAssessment?.getFormattedValue() ?? null),
         recommendations: Choice.withUseDefaultIfNull(variables.recommendations?.getFormattedValue() ?? null),
      };
      return command;
   }, []);
   return (
      <FormsTemplates.SendTemplateButton<VisitTemplateFormBean, VisitTemplate>
         disabled={props.disabled}
         handleSubmit={props.handleSubmit}
         commandCreator={(variables, id) => commandCreator(variables, id as number)}
         onSuccess={props.onSuccess}
         shouldConfirm={{
            enabled: props.shouldConfirmEmptyTemplate,
            title: visitTemplatesTranslationKeys.savingEmptyTemplate,
            content: visitTemplatesTranslationKeys.doYouWantToSaveEmptyTemplate,
         }}
      />
   );
};
